<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">
    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div class="column is-12" style="overflow:auto; display:block" [style.maxHeight.px]="tamano-85">


            <section class="hero is-primary welcome is-small">
                <div class="hero-head">
                    <div class="container">
                        <br>
                        <h1 class="title">
                            Facturación electronica.
                        </h1>
                    </div>
                </div>
                <div class="hero-body">
                    <div class="container">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">

                                    <h2 class="subtitle">
                                        Administración de CFDI
                                    </h2>
                                </div>

                            </div>

                            <!-- Right side -->
                            <div class="level-right">

                                <a class="navbar-item tooltip" (click)="estadistica()">
                                    <span class="icon fa-2x">
                                        <i class="icon-worldwide"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>
                            </div>
                        </nav>
                    </div>
                </div>
            </section>
            <div class="is-fullwidth has-text-centered" *ngIf="cargando">
                <br>
                <span class="tag is-primary is-large ">
                    <span class="icon">
                        <i class="icon-worldwide fa-spin"></i>
                    </span> &nbsp;
                    <span>Cargando...</span>
                </span>
                <br>
                <br>
            </div>
            <div class="is-fullwidth has-text-centered" *ngIf="!cargando">

                <div class="notification is-black" *ngIf="sin_resultado != ''">
                    ¡Mesaje del servidor!
                    <strong>{{sin_resultado}}</strong>
                </div>

                <section class="info-tiles" *ngIf="dashboard.facturas">
                    <div class="tile is-ancestor has-text-centered">
                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-success">
                                                <i class="fa fa-check fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.facturas.completo}}</p>
                                            <p class="subtitle">Correctos</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>

                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-danger">
                                                <i class="fa fa-close fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.facturas.cancelado}}</p>
                                            <p class="subtitle">Cancelados</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>

                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-warning">
                                                <i class="fa fa-hourglass-end fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.facturas.pendiente}}</p>
                                            <p class="subtitle">Pendientes</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>

                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-info">
                                                <i class="fa fa-qrcode fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.facturas.porcentaje}} %</p>
                                            <p class="subtitle">Porcentaje</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>
                    </div>
                </section>
                <div class="columns" *ngIf="dashboard.facturas">

                    <div class="column is-6">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title">
                                    Conoce nuestros planes
                                </p>
                                <a href="#" class="card-header-icon" aria-label="more options">
                                    <span class="icon">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </a>
                            </header>

                            <div class="card-content">
                                <div class="media">
                                    <div class="media-left">
                                        <figure class="image is-128x128">
                                            <span class="fa-5x">
                                                <i class="fa fa-files-o "></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <p class="title is-1">{{dashboard.facturas.total}}</p>
                                        <p class="subtitle">Todos tus CFDI</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div class="column is-6">
                        <div class="card">
                            <header class="card-header">
                                <p class="card-header-title">
                                    Modifica tus datos
                                </p>
                                <a href="#" class="card-header-icon" aria-label="more options">
                                    <span class="icon">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                    </span>
                                </a>
                            </header>
                            <div class="card-content">
                                <div class="media">
                                    <div class="media-left">
                                        <figure class="image is-128x128">
                                            <span class="fa-5x has-text-dark">
                                                <i class="fa fa-file "></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <p class="title is-1">{{dashboard.facturas.disponible}}</p>
                                        <p class="subtitle">CFDI Disponibles</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <section class="info-tiles" *ngIf="dashboard.facturas">
                    <div class="tile is-ancestor has-text-centered">
                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-link">
                                                <i class="fa fa-certificate fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.total_mes}} </p>
                                            <p class="subtitle">Timbres del mes</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>

                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-warning">
                                                <i class="fa fa-key fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.progreso_fiscal}} %</p>
                                            <p class="subtitle">Configuracón de datos fiscales</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>

                        <div class="tile is-parent">
                            <article class="tile is-child box">
                                <article class="media">
                                    <div class="media-left">
                                        <figure class="image is-64x64">
                                            <span class=" has-text-info">
                                                <i class="fa fa-address-card fa-3x"></i>
                                            </span>
                                        </figure>
                                    </div>
                                    <div class="media-content">
                                        <div class="content">
                                            <p class="title">{{dashboard.progreso_datos}} %</p>
                                            <p class="subtitle">Configuración de domicilio</p>
                                        </div>
                                    </div>
                                </article>
                            </article>
                        </div>
                    </div>
                </section>
            </div>

        </div>

    </div>
</div>